import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const BlululupFlow = () => {
  return (
    <Flow>
      <Flow.Progress label='Blululup Flow' />

      <Flow.StepList>
        <Step name='phone-natural' />
        <Step name='occupation-natural' />
        <Step name='the-end' />
      </Flow.StepList>
    </Flow>
  );
};
